// Mirrors backend value.TIERS: longer prices need a bigger edge to be listed.
export const TIERS = [
  { id: 1, label: "Standard", hint: "Odds ≤ 2.00 · EV ≥ 10%", max: 2 },
  { id: 2, label: "Medium", hint: "Odds 2.01 – 4.00 · EV ≥ 15%", max: 4 },
  { id: 3, label: "High", hint: "Odds > 4.00 · EV ≥ 20%", max: Infinity },
];

export const inTier = (p, id) => p.odds <= TIERS[id - 1].max && (id === 1 || p.odds > TIERS[id - 2].max);

export function ValueTiers({ tier, onChange, picks }) {
  return (
    <div className="vs-block" data-testid="value-tiers">
      <span className="vs-label">Odds category</span>
      <div className="vs-tiergrid">
        {TIERS.map((t) => (
          <button key={t.id} type="button" className={tier === t.id ? "is-active" : ""} onClick={() => onChange(t.id)} data-testid={`value-tier-${t.id}`}>
            {t.label}<small>{picks?.filter((p) => inTier(p, t.id)).length ?? 0}</small>
          </button>
        ))}
      </div>
      <span className="vs-hint" data-testid="value-tier-hint">{TIERS[tier - 1].hint}</span>
    </div>
  );
}
